import * as yup from 'yup';

const descriptionMaxLength: number = 5000;

export const SampleMethodologyScheme = yup.object({
    policyDetail: yup
    .string()
    .max(descriptionMaxLength, "Policy Detail is too long")
    .required('Policy Detail is required')
    .min(4, 'Policy Detail is too short')
    .nullable(),
    
    lowRisk: yup
    .number()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required('Low risk is required')
    .typeError('Low risk should have digits only')
    .min(0, "Low Risk cannot be less than 0%")
    .max(100, "Low Risk cannot be more than 100%"),

    mediumRisk: yup
    .number()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required('Medium risk is required')
    .typeError('Medium risk should have digits only')
    .min(0, "Medium Risk cannot be less than 0%")
    .max(100, "Medium Risk cannot be more than 100%"),

    highRisk: yup
    .number()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required('High risk is required')
    .typeError('High risk should have digits only')
    .min(0, "High Risk cannot be less than 0%")
    .max(100, "High Risk cannot be more than 100%"),

    interviewSamplePercentage: yup
    .number()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required('Interview sample is required')
    .typeError('Interview sample should have digits only')
    .min(0, "Interview sample cannot be less than 0%")
    .max(100, "Interview sample cannot be more than 100%")
})